import createCardListingView from '../Views/createCardListingView';
import FlexTopicCard from './FlexTopicCard';

export default createCardListingView(FlexTopicCard, {
  displayName: 'TopicListingView',
});
